import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  RequestGetCompanyDto,
  ResponseGetCompanyDto,
} from "../dto/sf-company.dto";

@Injectable()
export class SfCompanyApi {
  private readonly service: string = '';
  private readonly model: string = 'sfCompany';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getCompany(payload: RequestGetCompanyDto): Observable<ResponseGetCompanyDto> {
    const method: string = 'POST';
    const func: string = 'getCompany';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetCompanyDto>(method, url, params, urlParams, body, null, null, null, false);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-company.api.ts